// Module
var code = "<section class=\"Feedback\"> <div class=\"Feedback__content\"> <h3 class=\"Feedback__heading\">We appreciate your feedback!</h3> <p class=\"Feedback__body\"> Your opinion helps us shape what kinds of messages we'll send in the future. </p> </div> </section> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/feedback/feedback.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;